import { render, staticRenderFns } from "./AgentCardDeck.vue?vue&type=template&id=bf03556a&"
import script from "./agent-card-deck.ts?vue&type=script&lang=ts&"
export * from "./agent-card-deck.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports